import React from 'react';
import { useTranslation } from '../../i18n/i18n';
import { Reading } from '../../models/reading';
import { agoUnit } from '../../utils/format';
import './StatusPill.scss';

/** A device is online while it keeps reporting within this window. */
export const ONLINE_THRESHOLD_MS = 60 * 60 * 1000;

export const useAgo = () => {
  const { t } = useTranslation('common');
  return (date: Date) => {
    const unit = agoUnit(date);
    return unit.key === 'now' ? t('ago.now') : t(`ago.${unit.key}`, { count: unit.count });
  };
};

const StatusPill = ({ latest }: { latest?: Reading | null }) => {
  const { t } = useTranslation('common');
  const ago = useAgo();
  if (latest === undefined) return null;
  if (latest === null) return <span className="StatusPill StatusPill--idle">{t('status.noData')}</span>;
  const online = Date.now() - latest.time.getTime() < ONLINE_THRESHOLD_MS;
  return (
    <span className={`StatusPill StatusPill--${online ? 'online' : 'offline'}`}>
      <span aria-hidden="true" className="StatusPill__dot" />
      {t(online ? 'status.online' : 'status.offline', { ago: ago(latest.time) })}
    </span>
  );
};

export default StatusPill;
